export const mobileBreakpoint = 700;
export const TabletBreakpoint = 1280;
